{
  "name": "@codbex/harmonia",
  "version": "2.14.1",
  "description": "A Modern UI Component Library for Alpine.js",
  "repository": {
    "url": "git+https://github.com/codbex/harmonia.git",
    "type": "git"
  },
  "type": "module",
  "main": "dist/harmonia.min.js",
  "module": "dist/harmonia.esm.min.js",
  "unpkg": "dist/harmonia.min.js",
  "exports": {
    ".": {
      "import": "./dist/harmonia.esm.min.js",
      "default": "./dist/harmonia.min.js"
    },
    "./dist/harmonia.css": "./dist/harmonia.css",
    "./dist/harmonia-extend.css": "./dist/harmonia-extend.css",
    "./package.json": "./package.json"
  },
  "keywords": [],
  "author": "StanGenchev",
  "license": "MIT",
  "contributors": [
    {
      "name": "Stan Genchev",
      "email": "stan.genchev@codbex.com",
      "url": "https://github.com/StanZGenchev"
    }
  ],
  "files": [
    "dist/",
    "skills/"
  ],
  "scripts": {
    "build": "node ./scripts/build.cjs && npm run tailwind && npm run agent-docs:generate && node ./scripts/doc-build.cjs",
    "build:prod": "node ./scripts/build.cjs && npm run tailwind && npm run extend-css:generate && npm run agent-docs:generate",
    "icons:generate": "node ./scripts/generate-icons.cjs",
    "agent-docs:generate": "node ./scripts/generate-agent-docs.cjs",
    "extend-css:generate": "node ./scripts/generate-extend-css.cjs",
    "theming:generate": "node ./scripts/generate-theming-fragments.cjs && prettier --write \"docs/public/theming/fragments/*.html\" \"docs/public/theming/sections.json\" --config ./.prettierrc",
    "tailwind": "npx @tailwindcss/cli -m -i src/styles/globals.css -o dist/harmonia.css",
    "tailwind:watch": "npx @tailwindcss/cli -m -i src/styles/globals.css -o dist/harmonia.css -w",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "lint": "eslint \"src/**/*.js\" \"scripts/**/*.cjs\"",
    "lint:fix": "eslint --fix \"src/**/*.js\" \"scripts/**/*.cjs\"",
    "format": "prettier --write \"**/*.{js,jsx,ts,tsx,json,css,scss,md,html,yaml}\" --config ./.prettierrc",
    "format:check": "prettier --check \"**/*.{js,jsx,ts,tsx,json,css,scss,md,html,yaml}\" --config ./.prettierrc",
    "docs:install": "node ./scripts/doc-install.cjs",
    "docs:dev": "vitepress dev docs",
    "docs:build": "vitepress build docs",
    "docs:preview": "vitepress preview docs"
  },
  "docDependencies": {
    "alpinejs": "^3.15.12",
    "i18next": "^26.3.4",
    "lucide": "^1.20.0",
    "culori": "^4.0.2",
    "@fontsource/open-sans": "^5.2.7",
    "pinecone-router": "^7.6.0"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@tailwindcss/cli": "^4.3.3",
    "@vitest/coverage-v8": "^4.1.9",
    "alpinejs": "^3.15.12",
    "autoprefixer": "^10.5.0",
    "esbuild": "^0.28.1",
    "eslint": "^10.5.0",
    "eslint-config-prettier": "^10.1.8",
    "globals": "^17.6.0",
    "happy-dom": "^20.10.4",
    "prettier": "^3.8.4",
    "prettier-plugin-organize-imports": "^4.3.0",
    "prettier-plugin-tailwindcss": "^0.8.0",
    "tailwindcss": "^4.3.3",
    "vitepress": "^2.0.0-alpha.19",
    "vitest": "^4.1.9"
  },
  "peerDependencies": {
    "alpinejs": "^3.15.12"
  },
  "dependencies": {
    "@floating-ui/dom": "^1.8.0"
  }
}
